import { purposeChanged, connectedPurposeChanged } from "../../actions/filters";
import makeSelect from "../../../../shared/make_select";

export default  (purposeCountryParamMultiFilterMode = false) => {
  const valueSelector = (state) => state.filters.purpose.selectedValue;
  const optionsSelector = (state) => state.filters.purpose.options;
  const changeCallback = purposeCountryParamMultiFilterMode ? connectedPurposeChanged : purposeChanged;

  return makeSelect(changeCallback, "Application", valueSelector, optionsSelector, { clearable: false }, { "col-md-3": true });
};
